module.exports = __webpack_public_path__ + "img/account-management-authority.4ec39c40.png";